import { computed, type ComputedRef } from 'vue';
import type { JobList, JobSort, ListFilter } from '@/graphql/types-optimize';
import { useQuery } from '@vue/apollo-composable';
import gql from 'graphql-tag';

export const useJobList = (
    dead: boolean,
    filter: ComputedRef<ListFilter | undefined>,
    sort: ComputedRef<JobSort | undefined>
) => {
    const fields = `items {
            id
            queue
            ty
            objectId
            payload
            retries
            scheduledAt
            startedAt
            enqueuedAt
            priority
            dead
            diedAt
        }
        limit
        total
        page`;
    const { result, refetch, loading } = useQuery<{
        jobs: JobList;
        deadJobs: JobList;
    }>(
        dead
            ? gql`
                  query DeadJobs($filter: ListFilter, $sort: JobSort) {
                      deadJobs(filter: $filter, sort: $sort) {
                          ${fields}
                      }
                  }
              `
            : gql`
                  query Jobs($filter: ListFilter, $sort: JobSort) {
                      jobs(filter: $filter, sort: $sort) {
                        ${fields}
                      }
                  }
              `,
        () => ({
            filter: filter.value,
            sort: sort.value
        }),
        { clientId: 'optimize' }
    );
    const defaultValue: JobList = {
        items: []
    };
    const jobs = computed(() =>
        dead
            ? (result.value?.deadJobs ?? defaultValue)
            : (result.value?.jobs ?? defaultValue)
    );
    return { jobs, refetch, loading };
};
